export default "__VITE_ASSET__790fe5d0__"